export default __webpack_public_path__ + "static/media/signup.dc1e02db.jpg";